import MultiSelect from '@/components/MultiSelect';
import type { MultiSelectOption } from '@/components/MultiSelect/types';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Props = CFormItemProps & {
  value: string[];
  onChange?: (value: string[]) => void;
  options: MultiSelectOption[];
  /** 空の場合の表示テキスト */
  placeholder?: string;
  /** 空の選択を許可するか */
  allowEmpty?: boolean;
  /** 入力フィールドの幅 */
  inputWidth?: number | string;
};

/**
 * Card-based Form / MultiSelectItem
 */
export const CFormMultiSelectItem = buildCFormItem((props: Props) => {
  const {
    value,
    placeholder = '-',
    onChange,
    allowEmpty = false,
    inputWidth,
    readonly,
    options,
    ...restProps
  } = props;
  const readComponent = (() => {
    if (!value || value.length === 0) return placeholder;
    const selectedLabels = value.map(val => options.find(option => option.value === val)?.label).filter(Boolean);
    if (selectedLabels.length === 0) return placeholder;

    // 複数項目を改行で表示
    return <div className="space-y-1">
        {selectedLabels.map(label => <div key={label}>{label}</div>)}
      </div>;
  })();
  const writeComponent = readonly ? readComponent : <div style={{
    width: inputWidth
  }}>
      <MultiSelect options={options} value={value} onValueChange={newValue => {
      // allowEmptyがfalseの場合、少なくとも1つの選択を維持
      if (!allowEmpty && newValue.length === 0) {
        return;
      }
      onChange?.(newValue);
    }} disabled={readonly} />
    </div>;
  return <CFormItemBase {...restProps} readComponent={readComponent} writeComponent={writeComponent} />;
});